import { FC, HTMLAttributes, ReactNode } from "react";
import SharedSorters from "src/components/SortersBar/Sorters";
import { SorterLabel } from "src/components/SortersBar/SorterButton";
import { computeHotelLabels, defaultRenderLabel } from "../utils";

const Sortersweb: FC<{
  dataGroups: Map<string, Map<number | string, any[]>>;
  sorters: any[];
  isLoading: boolean;
  activeSorter: string;
  activeValue?: boolean;
  pointsFactor: number;
  renderLabel?: (label: SorterLabel | null) => ReactNode;
} & HTMLAttributes<HTMLDivElement>> = ({
  activeValue,
  pointsFactor,
  ...props
}) => {
  return (
    <SharedSorters
      computeLabels={(group, sorter) => computeHotelLabels(group, sorter, pointsFactor)}
      renderLabel={defaultRenderLabel}
      {...props}
    />
  );
};

export default Sortersweb;
